import React, { FunctionComponent } from 'react';
import { CustomQuillEditor } from '../../../QuillEditor';
import { INoteEditorProps } from '../types';
import { FaTrash } from 'react-icons/fa6';

export const NoteEditor: FunctionComponent<INoteEditorProps> = ({
  note,
  title,
  content,
  onContentChange,
  onTitleChange,
  onContentBlur,
  onTitleBlur,
  onDeleteNote,
}) => {
  const handleTextChange = (newContent: string) => {
    onContentChange(newContent);
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onTitleChange(e.target.value);
  };

  const handleTitleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    onTitleBlur(e.target.value);
  };

  const handleContentBlur = () => {
    onContentBlur(content);
  };

  return (
    <div className="personal-notes-editor">
      {note ? (
        <>
          <div className="personal-notes-editor-header">
            <input
              type="text"
              className="personal-notes-editor-title"
              value={title}
              placeholder="Untitled"
              onChange={handleTitleChange}
              onBlur={handleTitleBlur}
            />
            <button className="remove-button" onClick={onDeleteNote}>
              <FaTrash />
            </button>
          </div>
          <div className="personal-notes-editor-content">
            <CustomQuillEditor key={note.id} value={content} onChange={handleTextChange} onBlur={handleContentBlur} />
          </div>
        </>
      ) : (
        <div className="personal-notes-editor-placeholder">
          <div className="personal-notes-editor-placeholder-content">
            <i className="icon-doc blueGray f-4"></i>
            <p className="blueGray mt-2">Select a note to view and edit</p>
          </div>
        </div>
      )}
    </div>
  );
};
